export const facilitiesData = [
  {
    id: 3563485963,
    title: "Many achievements",
    description: "Maktabimiz o'quvchilari  ko'plab yutuqlarga ega bo'lishdi.",
    icon: "dashicons:awards",
  },
  {
    id: 5563485963,
    title: "Bizning tajriba",
    description: "Maktabimiz 48 yildan beri o'z faoliyatini olib boradi.",
    icon: "mingcute:calendar-fill",
  },
  {
    id: 1563485963,
    title: "Kitobxonlik",
    description:
      "Kutubxonachimiz kitoblarni vaqtinchalik o'qishga berib turadilar.",
    icon: "ion:book",
  },
  {
    id: 2563485963,
    title: "Qisqa va unumli darslar",
    description: "Darslarimiz 45 daqiqadan bolib otadi.",
    icon: "material-symbols:speed",
  },
];
